export interface Currency {
  _id?: string
  code: string
  name: string
  symbol: string
  rateToBase: number
  symbolPosition: 'before' | 'after'
  decimalSeparator: string
  thousandsSeparator: string
  decimalPlaces: number
  isActive: boolean
}

export const initialCurrency: Currency = {
  code: '',
  name: '',
  symbol: '',
  rateToBase: 1,
  symbolPosition: 'before',
  decimalSeparator: '.',
  thousandsSeparator: ',',
  decimalPlaces: 2,
  isActive: true
} 